import { Flex, Text } from '@chakra-ui/react';
import { Divider, Grid } from '@time-line/components/common';
import { Fragment } from 'react';
import type { HowToEarnPoints as HowToEarnPointsType } from 'types/cms/blocks/HowToEarnPoints';

import { HowToEarnPointsCard } from './HowToEarnPointsCard';
import { useDistributedRows } from './useDistributedRows';

const dividerOpacitySvg = '/images/dividerOpacity.svg';

interface HowToEarnPointsProps extends HowToEarnPointsType {
  isDividerVisible?: boolean;
}

export const HowToEarnPoints = ({
  title,
  items,
  isDividerVisible,
}: HowToEarnPointsProps) => {
  const rows = useDistributedRows(items);

  return (
    <Grid my="xl">
      <Grid.Inner gridColumn="main" gridRowGap={{ base: 'sm', md: 'lg' }}>
        {isDividerVisible && <Divider gridColumn="1/-1" />}
        <Text size="h2" gridColumn="1 / -1" width="100%" textAlign="center">
          {title}
        </Text>
        {rows && (
          <Flex
            gridColumn="1 / -1"
            gap={{ base: 'sm', md: 'm' }}
            flexDirection="column"
            flexWrap="wrap"
            alignItems="center"
          >
            {rows.map((row, rowIdx) => (
              <Flex
                key={rowIdx}
                gap="md"
                position="relative"
                justifyContent="space-evenly"
                width="100%"
                flexDirection="row"
                flexWrap="nowrap"
                {...(rowIdx !== 0 && {
                  paddingTop: { base: 'sm', md: 'm' },
                  backgroundImage: `url(${dividerOpacitySvg})`,
                  backgroundRepeat: 'repeat-x',
                  backgroundSize: '6px 2px',
                  backgroundPosition: 'top left',
                })}
              >
                {row.map((item, cardIdx) => {
                  const isLastCard = cardIdx === row.length - 1;

                  return (
                    <Fragment key={cardIdx}>
                      <HowToEarnPointsCard
                        isFirstCard={cardIdx === 0}
                        isLastCard={isLastCard}
                        {...item}
                      />
                      {!isLastCard && (
                        <Divider dividerPosition="right" addOpacity />
                      )}
                    </Fragment>
                  );
                })}
              </Flex>
            ))}
          </Flex>
        )}
      </Grid.Inner>
    </Grid>
  );
};
